<template>
  <div>
    <div class="card-panel z-depth-2 pad">
      <p>
        При отправке происходит GET запрос на
        <a :href="'/api/echo/' + text">api/echo/:message</a>
      </p>
      <form @submit.prevent="onSubmit">
        <div class="input-field">
          <input type="text" placeholder="enter some text" v-model="text" />
        </div>
        <button class="waves-effect waves-light btn" type="submit">send</button>
      </form>
    </div>

    <div v-if="getResult" class="card-panel z-depth-2 pad">
      <p>Ответ сервера:</p>
      <p>{{ getResult }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      text: "",
    };
  },
  computed: mapGetters(["getResult", "getTest"]),
  methods: {
    ...mapActions(["echoApi"]),
    onSubmit() {
      this.echoApi(this.text);
      this.text = "";
    },
  },
};
</script>